export class EmojiUsage {
  constructor(public emoji: string, public usageCount: number) {}

  plusPlus() {
    this.usageCount++;
  }
}

export class MostUsedEmojis {
  sortedEmojiUsages: EmojiUsage[];

  constructor(usages: EmojiUsage[]) {
    this.sortedEmojiUsages = usages;
    this.sortUsages(); // not really needed as they will be stored sorted in the backend
  }

  registerUsage(emoji: string) {
    this.getOrCreateUsage(emoji).plusPlus();
    this.sortUsages();
  }

  private getOrCreateUsage(emoji: string): EmojiUsage {
    let result: EmojiUsage;
    for (const usage of this.sortedEmojiUsages) {
      if (usage.emoji === emoji) {
        result = usage;
        break;
      }
    }
    if (!result) {
      result = new EmojiUsage(emoji, 0);
      this.sortedEmojiUsages.push(result);
    }
    return result;
  }

  private sortUsages() {
    // sort by most used first
    this.sortedEmojiUsages.sort((u1, u2) => u2.usageCount - u1.usageCount);
  }
}
